module.exports = __webpack_public_path__ + "static/media/B44865 Administrative Penalty Order.b741d9bb.pdf";